import { render } from "./AuthorPayView.vue?vue&type=template&id=8cdcaa84"
import script from "./AuthorPayView.vue?vue&type=script&lang=js"
export * from "./AuthorPayView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__